import { useState, useEffect } from "react";
import { toast } from "react-toastify";

const OfficeExpenseItemModal = ({ isOpen, onClose, onSave, itemToEdit }) => {
  const isEditMode = !!itemToEdit;
  const [formData, setFormData] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (isEditMode && itemToEdit) {
        setFormData({ name: itemToEdit.name || "" });
      } else {
        setFormData({ name: "" });
      }
      setErrors({});
      setIsLoading(false);
    }
  }, [isOpen, itemToEdit, isEditMode]);

  const handleSave = async () => {
    if (!formData.name.trim()) {
        setErrors({ name: "Expense Item Name is required" });
        toast.error("Please enter a name.");
        return;
    }
    
    try {
      setIsLoading(true);
      await onSave({ 
          ...formData, 
          id: isEditMode ? itemToEdit.id : null 
      }, isEditMode);
    } catch (error) {
      console.error("Save failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg">
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold text-gray-700">{isEditMode ? "Edit Expense Item" : "Add Expense Item"}</h2>
        </div>
        
        <div className="p-6">
           <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                 Expense Item Name <span className="text-red-500">*</span>
              </label>
              <input 
                type="text" 
                className={`w-full p-2 border rounded-md outline-none focus:ring-0 font-inter font-medium text-sm text-gray-700 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                value={formData.name} 
                onChange={e => {
                    setFormData({ name: e.target.value });
                    if(errors.name) setErrors({});
                }} 
                placeholder="e.g. Electricity, Internet"
                disabled={isLoading}
              />
              {errors.name && <span className="text-red-500 text-xs mt-1">{errors.name}</span>}
           </div>
        </div>

        <div className="p-6 border-t flex justify-end gap-3 bg-gray-50 rounded-b-lg">
           <button 
             onClick={onClose} 
             className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300" 
             disabled={isLoading}
           >
             Cancel
           </button>
           <button 
             onClick={handleSave} 
             className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200 flex items-center gap-2" 
             disabled={isLoading}
           >
             {isLoading ? (
               <>
                 <span>Saving...</span>
               </>
             ) : (
               "Save"
             )}
           </button>
        </div>
      </div>
    </div>
  );
};

export default OfficeExpenseItemModal;